'use client';

import { useCallback } from 'react';

import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalGroupBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalGroupBtn';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import * as S from './style';

interface IProps {
  onSubmit?: () => void;
  onClose?: () => void;
  value: {
    text: string;
    btnType?: 'single' | 'double' | string;
    submitText?: string;
    closeText?: string;
    isIPhoneXApp: boolean;
    isDesktop: boolean;
  };
}

const NoticeModal = ({ onSubmit, onClose, value }: IProps) => {
  const {
    text,
    btnType = 'single',
    submitText = '동의',
    closeText = '미동의',
    isIPhoneXApp,
    isDesktop,
  } = value;

  // EVENT HANDLER : 동의
  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') onSubmit();
  }, [onSubmit]);

  // EVENT HANDLER : 닫기
  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.NoticeModal className={`btn-type-${btnType}`}>
      {isDesktop ? (
        <ModalCloseBtn onClick={handleClose} />
      ) : (
        <ModalEdgeCloseBtn onClick={handleClose} />
      )}
      <div className="content">
        {text && (
          <Text block className="desc">
            {text}
          </Text>
        )}
      </div>
      <ModalGroupBtn
        secondaryBtn={
          btnType !== 'single'
            ? { text: closeText, onClick: handleClose }
            : undefined
        }
        primaryBtn={{
          text: submitText,
          onClick: handleSubmit,
        }}
      />
    </S.NoticeModal>
  );
};

export default NoticeModal;
